var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { TableRow as MuiTableRow, TableCell as MuiTableCell } from '@mui/material';
var StyledMuiRow = styled(MuiTableRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #f5f5f5;\n  margin: 0;\n  padding: 0;\n  border: 0;\n"], ["\n  background-color: #f5f5f5;\n  margin: 0;\n  padding: 0;\n  border: 0;\n"])));
var StyledMuiCell = styled(MuiTableCell)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: none !important;\n"], ["\n  border: none !important;\n"])));
export default function TableEmptyState(props) {
    var _a;
    var config = props.config;
    var content = (_a = config === null || config === void 0 ? void 0 : config.emptyStateRenderer) === null || _a === void 0 ? void 0 : _a.call(config);
    if (!content)
        return null;
    return (_jsx(StyledMuiRow, { children: _jsx(StyledMuiCell, __assign({ colSpan: 999 }, { children: content })) }));
}
var templateObject_1, templateObject_2;
